// 会场状态
export const venueStatus = {
  1: { label: '待开始', value: 1, color: 'orange' },
  2: { label: '进行中', value: 2, color: 'blue' },
  3: { label: '已完成', value: 3, color: 'green' },
  4: { label: '已终止', value: 4, color: 'red' }
};

// 会场活动类型
export const venueActivity = {
  1: { label: '需求竞拍', value: 1, color: 'cyan' },
  2: { label: '需求预约', value: 2, color: 'purple' },
  3: { label: '排队选择', value: 3, color: 'gold' }
};

// 会场竞拍产品状态
export const venueProductStatus = {
  1: { label: '待竞拍', value: 1, color: 'blue', class: 'status-wait' },
  2: { label: '竞拍中', value: 2, color: 'orange', class: 'status-bidding' },
  3: { label: '已竞拍', value: 3, color: 'green', class: 'status-completed' },
  4: { label: '流拍', value: 4, color: 'red', class: 'status-failed' }
};

// 会场状态
export const venueRecordStatus = {
  1: { label: '进行中', value: 1, color: 'blue' },
  2: { label: '等待中', value: 2, color: 'orange' },
  3: { label: '已接受', value: 3, color: 'green' },
  4: { label: '已放弃', value: 4, color: 'red' }
};
